import { useSignUpPass } from "@/features/user/hooks/use-sign-up-pass";
import { SignUpPassService } from "@/features/user/services/sign-up-pass-service";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { PasswordForm } from "@/shared/components/text-box/password-form";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LoginHeader } from "@/shared/components/header/login-header";
import { Footer } from "@/shared/components/footer/footer";
import { StrengthBar } from "@/shared/components/strength-bar/strength-bar";
import { useErrorContext } from "@/shared/context/error-context";
import { MoneyLinkWarning } from "@/shared/utils/custom-exception";
import { EndpointPathNames } from "@/shared/config/endpoint-path";

export const SignUpPass = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token") ?? "";
  const navigate = useNavigate();
  const { setError } = useErrorContext();
  const signUpPassService = new SignUpPassService();
  const [initSuccess, setInitSuccess] = useState(false);
  const {
    password,
    passwordConfirm,
    passwordError,
    isActiveNextButton,
    onChangePassword,
    onChangePasswordConfirm,
    changeNextButtonState,
    onClickNext,
  } = useSignUpPass();

  useEffect(() => {
    const load = async () => {
      try {
        const res = await signUpPassService.signUpPassInit({token: token});

        if (!res.ok) {
          setError(new MoneyLinkWarning({
            title: "確認",
            message: res.errorMessage
          }));
          navigate(EndpointPathNames.LOGIN)
          return;
        }
        setInitSuccess(true);
      } catch {
        // ネットワークエラー等
        navigate("/error");
      }
    };

    load();
  }, [navigate]);

  useEffect(() => {
    if (!initSuccess) return;
    changeNextButtonState();
  }, [password, passwordConfirm, initSuccess]);

  // パスワードフォームに付与するID
  const passwordFormId = "signUpPass";
  // 次へボタンに付与するID
  const nextButtonId = "btnSignUp";

  return (
    <>
      <LoginHeader content="新しいアカウントを作成" />
      <main>
        <section id="signUp">
          <nav className="step">
            <ol>
              <li className="done">仮登録メールを送信</li>
              <li className="active">パスワードの設定</li>
              <li>ユーザー名の設定</li>
              <li>登録完了</li>
            </ol>
          </nav>
          <p>パスワードを設定してください</p>
          <ul className="form">
            <li>
              <PasswordForm
                onChange={onChangePassword}
                id={passwordFormId}
                // errorMessage={passwordError}
                title="パスワード"
                className="signUpPass"
              />
              <StrengthBar password={password} />
              <PasswordForm
                onChange={onChangePasswordConfirm}
                id={passwordFormId}
                // errorMessage={passwordError}
                title="パスワード（確認用）"
                className="signUpPass"
                placeholder="上と同じ内容をもう一度入力"
              />
              {passwordError && <span className="pass_error">{passwordError}</span>}
            </li>
          </ul>
          <div className="notice">
            <p>パスワードは半角英数8文字以上の文字列を使用してください。</p>
            <p>記号は利用できません。</p>
          </div>
          <nav className="btns">
            <BaseRoundButton
              id={nextButtonId}
              buttonText="次へ"
              onClick={() => onClickNext(token, password, passwordConfirm)}
              isActive={isActiveNextButton}
              className="nav-main"
            />
          </nav>
        </section>
      </main>
      <Footer />
    </>
  );
};
